import { MutationTree } from 'vuex';
import { ISykFieldInfo, IVerificationState } from './verification.types';

const verificationMutations: MutationTree<IVerificationState> = {
  setSykValue(state, sykValue: string): void {
    state.sykValue = sykValue;
  },

  setNetworkError(state, error: string): void {
    state.networkError = error;
  },

  setSykInfo(state, payload: ISykFieldInfo) {
    state.sykFieldInfo = payload;
  },
};

export default verificationMutations;
